// extracted by mini-css-extract-plugin
module.exports = {"header":"header--KlG_u","title":"title--3OeOX","extraHeader":"extraHeader--XC-5z"};